import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="login-page">
        <div className="login-form">
          <h1>Labret CRM</h1>
          <p style={{ marginBottom: 8 }}>Check your WhatsApp</p>
          <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 24 }}>
            If that email is registered with a phone number on file, you'll receive a WhatsApp message with a reset link. It expires in 1 hour.
          </p>
          <Link to="/login" style={{ fontSize: 14, color: '#6b7280' }}>Back to sign in</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <form className="login-form" onSubmit={handleSubmit}>
        <h1>Labret CRM</h1>
        <p style={{ marginBottom: 8 }}>Reset your password</p>
        <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 24 }}>
          Enter your email and we'll send a reset link to your registered WhatsApp number.
        </p>
        {error && <div className="error">{error}</div>}
        <label>Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoFocus
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Send reset link'}
        </button>
        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <Link to="/login" style={{ fontSize: 14, color: '#6b7280' }}>Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}

export default ForgotPassword;
